/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { first, Subject } from "rxjs";
import { ModalComponent } from "typedb-cloud-framework";
import { DialogResult } from "../../../../service/dialog.service";
import { UserApi } from "../../../../service/user/user-api.service";
import { MfaSetupComponent } from "../mfa-setup.component";

@Component({
    selector: "tp-mfa-setup-dialog",
    templateUrl: "./mfa-setup-dialog.component.html",
    standalone: true,
    imports: [
        ModalComponent, AsyncPipe, MfaSetupComponent
    ],
})
export class MfaSetupDialogComponent {

    readonly isSubmitting$ = new Subject<boolean>();

    constructor(private dialogRef: MatDialogRef<MfaSetupDialogComponent, DialogResult>, private userApi: UserApi) { }

    onSuccess() {
        this.userApi.syncMfa().pipe(first()).subscribe();
        this.close("ok");
    }

    close(result?: DialogResult) {
        this.dialogRef.close(result);
    }
}
